export const renderRepresentativeExample = (template, values) => {
    if (!template) return '';
    return template.replace(/\{(amount|duration|monthly|totalAmount|apr|aprc|currency|firstInstallment|lastInstallment|remainingCount|remainingInstallment|loanOriginationFee)\}/g, (_, key) => {
        const v = values[key];
        return v === undefined || v === null ? '' : String(v);
    });
};
